let centsToMoney = (cents_value) => {
  const splited_value = String(cents_value / 100.0).split('.')
  const int_part      = splited_value[0]
  let dec_part        = splited_value[1]
  dec_part            = (typeof dec_part === 'undefined' ? '00' : (dec_part.length === 1 ? dec_part + '0' : dec_part))
  return `${int_part}.${dec_part}`
}

export default { centsToMoney }


// WEBPACK FOOTER //
// ./src/shared/Utils.js